import { ProductScreenshot } from 'components/ProductScreenshot';
import EventsInPostHogLight from "../../../../contents/images/tutorials/php-feature-flags/events-light.png";
import EventsInPostHogDark from "../../../../contents/images/tutorials/php-feature-flags/events-dark.png";
import CreateFlagLight from "../../../../contents/images/tutorials/php-feature-flags/events-light.png";
import CreateFlagDark from "../../../../contents/images/tutorials/php-feature-flags/events-dark.png";
import FlagCaptureLight from "../../../../contents/images/tutorials/php-feature-flags/flag-capture-light.png";
import FlagCaptureDark from "../../../../contents/images/tutorials/php-feature-flags/flag-capture-dark.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  EventsInPostHogLight,
  EventsInPostHogDark,
  CreateFlagLight,
  CreateFlagDark,
  FlagCaptureLight,
  FlagCaptureDark,
  React
};